import { createAction } from '@reduxjs/toolkit';

import type { CreateSessionInput } from '../infrastructure/sessions.gateway';

/**
 * "Signal" actions: intents the UI dispatches for the saga. No reducers: they
 * trigger side effects (polling, the create write), not state transitions. The
 * saga owns the resulting `load*` / `stats*` / `create*` transitions.
 *
 * The panel's data fetches are driven directly by the slice's `panel*` reducer
 * actions (the saga watches those types), so they need no signal action here.
 */

/** Start the sessions-table poll loop (dispatched by the page on mount). */
export const sessionsRequested = createAction('sessions/sessionsRequested');
/** Stop the sessions-table poll loop (page unmount). */
export const sessionsStopped = createAction('sessions/sessionsStopped');

/** Start the KPI-stats poll loop (dispatched by the page on mount). */
export const statsRequested = createAction('sessions/statsRequested');
/** Stop the KPI-stats poll loop (page unmount). */
export const statsStopped = createAction('sessions/statsStopped');

/** Submit the New Session panel: create an enrichment session. */
export const submitRequested = createAction<CreateSessionInput>('sessions/submitRequested');
